import type { ParseApiError } from "./types";

export const parseApiError: ParseApiError = ({ error }) => {
  if (!(error instanceof Error)) {
    return { message: String(error), status: null, errorCode: null };
  }

  const status =
    "status" in error && typeof error.status === "number" ? error.status : null;

  const errorCode =
    "errorCode" in error && typeof error.errorCode === "string"
      ? error.errorCode
      : null;

  return { message: error.message, status, errorCode };
};
